import { useMutation, useQueryClient } from "@tanstack/react-query";
import { plantoesApi } from "../api/plantoesApi";
import { invalidateShiftQueries } from "./invalidateShiftQueries";
import { trackEvent } from "../../../shared/lib/analytics";

// Várias datas avulsas de uma vez (mesmo vínculo, horas, valor e detalhes de agenda).
export function useCreatePlantoesBatchMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: plantoesApi.createBatch,
    onSuccess: (resultado) => {
      trackEvent("plantao_registrado", { quantidade: resultado?.criados?.length ?? 0, lote: true });
      invalidateShiftQueries(queryClient);
    },
  });
}
